export default __webpack_public_path__ + "static/media/Notif - Certification Update.0a7b86fb.svg";